import { useLocalStorage } from '@uidotdev/usehooks';
import { LOCAL_STORAGE_KEYS } from 'src/contstant/commonLabels';
export const useUserAlias = () => {
  return useLocalStorage(LOCAL_STORAGE_KEYS.MIDWAY_AUTH_USERNAME, '');
};
